import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import { ConfirmationDialog } from '@dhl/confirmation-dialog'
import { useDeleteReturnHub } from '@dhl/mdp-api'
import { links } from '~/AppRoutes'
import { useNotificationMessage } from '~/common'
import { getErrorMessage } from '~/common/util/axiosUtil'

export const DeleteConfirmationDialog = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { id } = useParams()
  const { showError, showSuccess } = useNotificationMessage()
  const { mutateAsync: deleteReturnHub } = useDeleteReturnHub()

  const onAccept = async () => {
    try {
      if (id) {
        await deleteReturnHub({
          id,
        })
        showSuccess(t('admin.returnHubPage.deleteReturnHubSucces'))
        navigate(links.returnHubsLink())
      }
    } catch (error) {
      const message = getErrorMessage(error, t('admin.returnHubPage.deleteReturnHubError'))
      showError(message)
    }
  }

  const onReject = () => {
    navigate(links.returnHubsLink())
  }

  return (
    <ConfirmationDialog
      titleText={t('admin.returnHubPage.deleteConfirmationDialog.titleText')}
      acceptText={t('admin.returnHubPage.deleteConfirmationDialog.acceptText')}
      rejectText={t('admin.returnHubPage.deleteConfirmationDialog.rejectText')}
      onAccept={onAccept}
      onReject={onReject}
      open
    >
      {t('admin.returnHubPage.deleteConfirmationDialog.content')}
    </ConfirmationDialog>
  )
}
